document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('[data-testimonials-carousel]');
  carousels.forEach(initTestimonialsCarousel);
});

function initTestimonialsCarousel(root) {
  const viewport = root.querySelector('.fr-testimonials__viewport');
  const track = root.querySelector('.fr-testimonials__track');
  const slides = Array.from(root.querySelectorAll('.fr-testimonials__card'));
  const prevBtn = root.querySelector('.fr-testimonials__nav--prev');
  const nextBtn = root.querySelector('.fr-testimonials__nav--next');

  if (!viewport || !track || slides.length === 0) return;

  const slideCount = slides.length;
  const gap = 28; // matches ~1.75rem gap in CSS
  const cardWidth = slides[0].offsetWidth + gap;

  let originals = slides.slice();
  let loopOffset = 0;
  let totalWidth = 0;

  // ----------------------------------
  // Infinite loop via clones
  // ----------------------------------
  if (slideCount > 1) {
    totalWidth = cardWidth * slideCount; // width of one full set of originals

    // Prepend one full cloned set (for scrolling left)
    originals.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add('fr-testimonials__card--clone');
      track.insertBefore(clone, track.firstChild);
    });

    // Append one full cloned set (for scrolling right)
    originals.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add('fr-testimonials__card--clone');
      track.appendChild(clone);
    });

    // After prepending clones, the originals start after one full set:
    loopOffset = totalWidth;

    // When user scrolls too far into cloned regions, snap back into middle set
    viewport.addEventListener('scroll', () => {
      const current = viewport.scrollLeft;

      // Too far left into leading clones
      if (current <= loopOffset - totalWidth) {
        viewport.scrollLeft = current + totalWidth;
      }
      // Too far right into trailing clones
      else if (current >= loopOffset + totalWidth) {
        viewport.scrollLeft = current - totalWidth;
      }
    });
  }

  // ----------------------------------
  // Initial positioning (center first original on load)
  // ----------------------------------
  setTimeout(() => {
    const firstOriginal = originals[0];
    if (!firstOriginal) return;

    let targetLeft = firstOriginal.offsetLeft;

    // On mobile, center the first card so it isn't hidden behind the left nav
    if (window.innerWidth < 750) {
      targetLeft =
        firstOriginal.offsetLeft -
        (viewport.offsetWidth - firstOriginal.offsetWidth) / 2;
    }

    viewport.scrollTo({ left: targetLeft, behavior: 'auto' });
  }, 50);

  // ----------------------------------
  // Arrow navigation – always move one card
  // ----------------------------------
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      viewport.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      viewport.scrollBy({ left: cardWidth, behavior: 'smooth' });
    });
  }

  // ----------------------------------
  // Drag / swipe navigation
  // ----------------------------------
  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;

  const startDrag = (clientX) => {
    isDragging = true;
    startX = clientX;
    startScrollLeft = viewport.scrollLeft;
    viewport.classList.add('fr-testimonials--dragging');
  };

  const moveDrag = (clientX) => {
    if (!isDragging) return;
    const delta = clientX - startX;
    viewport.scrollLeft = startScrollLeft - delta;
  };

  const endDrag = () => {
    if (!isDragging) return;
    isDragging = false;
    viewport.classList.remove('fr-testimonials--dragging');
  };

  // Mouse events
  track.addEventListener('mousedown', (e) => {
    e.preventDefault();
    startDrag(e.clientX);
  });

  window.addEventListener('mousemove', (e) => moveDrag(e.clientX));
  window.addEventListener('mouseup', endDrag);

  // Touch events
  track.addEventListener(
    'touchstart',
    (e) => {
      const t = e.touches[0];
      startDrag(t.clientX);
    },
    { passive: true }
  );

  track.addEventListener(
    'touchmove',
    (e) => {
      const t = e.touches[0];
      moveDrag(t.clientX);
    },
    { passive: true }
  );

  track.addEventListener('touchend', endDrag);
}
